import React, {useEffect, useState} from 'react'
import {
  Button,
  Layout,
  Table,
  message,
  Spin,
  Space, Tooltip
} from 'antd';
import {Link, useNavigate, useParams} from "react-router-dom";
import { EditOutlined, FileExcelOutlined} from "@ant-design/icons";
import _ from "lodash";
import toernService from "../../../services/ToernService";
import dayjs from "dayjs";
import TableTitle from "../../base/TableTitle";
import {AbschlagIcon, ToernIcon} from "../../icons/CustomIcons";
import MonthSelector from "../../base/MonthSelector";

const { Content } = Layout;

const hfnFmt = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const BenutzerLetzterToernListe = () => {
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();

  const [toernliste, setToernliste] = useState([]);
  const [loading, setloading] = useState(true);
  const [feldFilter, setFeldFilter] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");

  const error = (msg) => {
    messageApi.open({
      type: 'error', content: msg,
    });
  }

  useEffect(() => {
    ladeLetzteToerns()
  }, []);

  const ladeLetzteToerns = async () => {
    setloading(true);
    await toernService.getLetzteToerns().then(
      res => {
        setloading(false);
        setToernliste(
          res.data.map(row => ({
            key: `t_${row.benutzer.id}`,
            benutzer: row.benutzer,
            eingereichtAm: row.eingereichtAm,
          }))
        )
      }
    ).catch((e) => {
      setloading(false);
      error(`Beim Laden der Liste ist ein Fehler aufgetreten:`);
      console.error(e);
    });
  };

  const handleChange = (pagination, filters, sorter) => {

    console.log("FI " + JSON.stringify(filters));
    setFeldFilter(filters);
  };

  const tabletitle = () => {
    return <TableTitle icon={<ToernIcon/>}
                  filtervalues={
                         toernliste
                           .reduce(function(acc, t) {
                             acc.push(t.benutzer.vorname);
                             acc.push(t.benutzer.nachname);
                             return acc;
                           }, [])
                           .filter((value, index, array) => array.indexOf(value) === index)
                           .map(s => ({ label: s, value: s}))
                       }
                  onFilter={setGlobalFilter} >Letzte eingereichte Törns</TableTitle>
  }

  const filterData = toernliste => formatter => toernliste.map( item => ({
    text: formatter(item),
    value: formatter(item)
  }));

  const columns=[
    {
      title: 'Benutzer',
      children: [
      {
        title: 'Vorname',
        dataIndex: 'benutzer',
        key: 'benutzerVorname',
        sorter: (a, b) => a.benutzer.vorname.localeCompare(b.benutzer.vorname),
        filters: _.uniqWith(filterData(toernliste)(i => i.benutzer.vorname), _.isEqual),
        filteredValue: feldFilter.benutzerVorname || null,
        onFilter: (value, record) => record.benutzer.vorname.includes(value),
        render: (benutzer) => <>{benutzer.vorname}</>
      },
      {
        title: 'Nachname',
        dataIndex: 'benutzer',
        key: 'benutzerNachname',
        sorter: (a, b) => a.benutzer.nachname.localeCompare(b.benutzer.nachname),
        filteredValue: feldFilter.benutzerNachname || null,
        filters: _.uniqWith(filterData(toernliste)(i => i.benutzer.nachname), _.isEqual),
        onFilter: (value, record) => {
          return record.benutzer.nachname.includes(value)
        },
        render: (benutzer) => <>{benutzer.nachname}</>
      }
    ]
    },
    {
      title: 'Törn',
      children: [
        {
          title: 'Eingereicht',
          dataIndex: 'eingereichtAm',
          key: 'eingereichtAm',
          sorter: (a, b) => (a.eingereichtAm == null) ? (b.eingereichtAm == null ? false : true) : a.eingereichtAm.localeCompare(b.eingereichtAm),
          filters: [
            {
              text: 'Vor dem 1.',
              value: 'beforeCurrentMonth',
            },
            ..._.filter(
              _.uniqWith(toernliste.map(item => ({
                text: item.eingereichtAm ? dayjs(new Date(item.eingereichtAm)).format('DD.MM.YYYY HH:mm') : "",
                value: item.eingereichtAm
              })), _.isEqual),
              value => (value.value !== null)
            )
          ],
          filteredValue: feldFilter.eingereichtAm || null,
          onFilter: (value, record) => {
            if (value === 'beforeCurrentMonth') {
              return (record.eingereichtAm === null) || dayjs(record.eingereichtAm).isBefore(dayjs().startOf('month'));
            }
            return record.eingereichtAm === value;
          },
          render: (datum) => <>{datum ? dayjs(new Date(datum)).format('DD.MM.YYYY HH:mm') : ""}</>,
        },
      ]
    },
    {
      title: 'Aktionen',
      dataIndex: 'benutzer',
      key: 'id',
      filteredValue: globalFilter ? [globalFilter] : null,
      onFilter: (value, record) =>
        record.benutzer.nachname.toString().toLowerCase().includes(value.toLowerCase()) ||
        record.benutzer.vorname.toString().toLowerCase().includes(value.toLowerCase())
      ,
      render: (benutzer, record) => <Space>
        <Tooltip title="Monatliche SFN-Zuschläge bearbeiten"><Link to={"/bordpersonal/details/" + benutzer.id }><Button icon={<AbschlagIcon />} /></Link></Tooltip>
      </Space>,
    }


  ]

  return (
    <>
      {contextHolder}
      <Layout>
        <Layout.Header style={{ backgroundColor: "#cccccc", display: 'flex',  alignItems: 'center'}}>
          <Space>
          </Space>
        </Layout.Header>
        <Content>
          {loading ? (
            <div style={{ padding: '16px' }}>
              <Spin size="large" />
            </div>
          ) : (
            <Table title={tabletitle} size={"small"} columns={columns} dataSource={toernliste} onChange={handleChange}></Table>
          )}
        </Content>
      </Layout>
    </>
  )
}

export default BenutzerLetzterToernListe